"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.redirect = redirect;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _raw = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/string/raw"));
/**
 * Redirects based on the provided status.
 *
 * @param status - The status of the response.
 * @param statusMap - A record mapping status codes (or regex patterns) to URLs.
 * @param options - See {@link RedirectOptions}
 * @returns `true` if redirected, `false` otherwise.
 *
 * @example
 * ```typescript
 * redirect(status, {
 *  404: '/not-found',
 *  '400|401|403': '/unauthorized',
 *  '.*': '/error', // catch-all
 * }, {
 * 	// optional 
 * 	redirect: url => routeTo(url),
 * });
 * ```
 */
function redirect(status, statusMap, options = {}) {
  const {
    redirect: redirectFn = defaultRedirect
  } = options;
  let route = statusMap[status] || statusMap['*'];
  if (!route) {
    // check for regex matches
    for (const key of (0, _keys.default)(statusMap)) {
      if (new RegExp((0, _raw.default)`${key}`).test(String(status))) {
        route = statusMap[key];
        break;
      }
    }
  }
  return route ? redirectFn(route) : false;
}
function defaultRedirect(url) {
  window.location.href = url;
  return true;
}